import React from 'react'
import { useTheme } from '@emotion/react'
import { LoadingButton } from '@mui/lab'
import { Box, Button, useMediaQuery } from '@mui/material'
import { isBoolean, isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

function ButtonBox({ buttons, mt, flexDirection }) {
  const theme = useTheme()
  const isMobile = !useMediaQuery(theme.breakpoints.up('lg'))

  return isEmpty(buttons) ? null : (
    <Box
      sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection, mt }}
    >
      {map(buttons, (btn, key) => {
        const MuiButton = isBoolean(btn.props?.loading) ? LoadingButton : Button

        return btn.hidden ? null : (
          <MuiButton
            key={key}
            sx={{
              mx: {
                xs: '4px',
                md: 1,
              },
              mb: 2,
              textAlign: 'center',
            }}
            {...btn.props}
          >
            {btn.icon && isMobile ? btn.icon : btn.label}
          </MuiButton>
        )
      })}
    </Box>
  )
}

ButtonBox.propTypes = {
  buttons: PropTypes.array,
  mt: PropTypes.number,
  flexDirection: PropTypes.string,
}

ButtonBox.defaultProps = {
  buttons: [],
  mt: 0,
  flexDirection: 'row',
}

export default ButtonBox
